import { Menu, UnstyledButton } from '@mantine/core';
import { Palettes } from '../Palettes/Palettes';
import { Trigger, Wrapper } from './QuickPalettes.style';

export type QuickPalettesProps = {
  palettes: IPalette[];
  onSelectPalette: (paletteId: string) => void;
};

export function QuickPalettes(props: QuickPalettesProps) {
  const { palettes } = props;

  return (
    <Wrapper className='QuickPalettes-wrapper' data-testid='QuickPalettes-wrapper'>
      <Menu>
        <Menu.Target>
          <UnstyledButton>
            <Trigger>Quick Palettes</Trigger>
          </UnstyledButton>
        </Menu.Target>
        <Menu.Dropdown>
          <Palettes
            palettes={palettes}
            selectedId=''
            onSelectPalette={props.onSelectPalette}
            onRestorePalette={() => {}}
          />
        </Menu.Dropdown>
      </Menu>
    </Wrapper>
  );
}

export default QuickPalettes;
